import React from 'react';
import { Provider } from 'react-redux';
import useAuthBootstrap from '../../hooks/useAuthBootstrap';
import Loader from 'wrapper/loader';

const AuthBootstrapWrapper = ({ children, store }) => {
  const { authLoaded, authError } = useAuthBootstrap();

  if (!authLoaded) {
    return (
      <Provider store={store}>
        <Loader message="Verifying session..." />
      </Provider>
    );
  }

  if (authError && import.meta.env.DEV) {
    console.warn('[AuthBootstrapWrapper] Bootstrap error:', authError);
  }

  return children;
};

export default AuthBootstrapWrapper;
